import { render } from "./CoffeeIcon.vue?vue&type=template&id=4eaa032e"
import script from "./CoffeeIcon.vue?vue&type=script&lang=js"
export * from "./CoffeeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__